module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSImIzIzMjsmIzE5MTsmIzE0ODsmIzIyOTsmIzE1NTsmIzE1ODsiPg0KPHBhdGggaWQ9IlJlY3RhbmdsZSAzNDYyNDM4MSIgZD0iTTYuODgzMyAzLjQ0OEwxMC45MzU0IDcuNTAwMDZMNi44ODMzIDExLjU1MjEiIHN0cm9rZT0iI0U5NkYyQiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPC9nPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/returnPro.svg
// module id = 1ee4
// module chunks = 0